import { ThemeProvider, createTheme } from "@mui/material/styles";
import React, { useContext } from "react";
import { ApolloProvider } from "@apollo/client";

import MainPage from "./main-page/MainPage";
import { AuthContext } from "./auth/AuthHook";
import { createApolloClient } from "./apollo/create-client";

const darkTheme = createTheme({
	palette: {
		// mode: "dark",
	},
});

const App = () => {
	const { loading, currentUser } = useContext(AuthContext);
	const client = createApolloClient();
	console.log("currentUser", currentUser);
	if (loading) return <div>Loading...</div>;
	return (
		<>
			<ApolloProvider client={client}>
				<ThemeProvider theme={darkTheme}>
					<div>
						<MainPage isAuth={!!currentUser} />
					</div>
				</ThemeProvider>
			</ApolloProvider>
		</>
	);
};

export default App;
